import React, { useState, useEffect } from 'react';
import api from '../api';

const SimManager = () => {
  const [bookings, setBookings] = useState([]);
  const [charges, setCharges] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [formData, setFormData] = useState({
    customer_name: '',
    customer_email: '',
    phone: '',
    booking_date: '',
    booking_time: '',
    duration_hours: 1,
    total_price: 50,
    deposit_paid: 0,
    card_last4: '',
    card_brand: '',
    status: 'confirmed',
    notes: ''
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [bookingsData, chargesData] = await Promise.all([
        api.adminGetSimBookings(),
        api.adminGetSimCharges()
      ]);
      setBookings(bookingsData);
      setCharges(chargesData);
    } catch (error) {
      console.error('Error loading SIM data:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedBooking) {
        await api.adminUpdateSimBooking(selectedBooking._id, formData);
      } else {
        await api.adminCreateSimBooking(formData);
      }
      setShowForm(false);
      setSelectedBooking(null);
      resetForm();
      await loadData();
    } catch (error) {
      console.error('Error saving booking:', error);
      alert('Failed to save booking');
    }
  };

  const handleCharge = async (bookingId, chargeType) => {
    const amounts = {
      no_show: 25,
      cleaning: 50,
      add_time: 25
    };
    
    const descriptions = {
      no_show: 'No-show fee',
      cleaning: 'Cleaning fee',
      add_time: 'Additional time charge'
    };

    const amount = prompt(`Enter amount for ${descriptions[chargeType]}:`, amounts[chargeType]);
    if (!amount) return;

    try {
      await api.adminChargeSimBooking(bookingId, {
        charge_type: chargeType,
        amount: parseFloat(amount),
        description: descriptions[chargeType]
      });
      alert(`Charge of $${amount} recorded successfully`);
      await loadData();
    } catch (error) {
      console.error('Error charging booking:', error);
      alert('Failed to record charge');
    }
  };

  const resetForm = () => {
    setFormData({
      customer_name: '',
      customer_email: '',
      phone: '',
      booking_date: '',
      booking_time: '',
      duration_hours: 1,
      total_price: 50,
      deposit_paid: 0,
      card_last4: '',
      card_brand: '',
      status: 'confirmed',
      notes: ''
    });
  };

  const editBooking = (booking) => {
    setSelectedBooking(booking);
    setFormData({
      customer_name: booking.customer_name,
      customer_email: booking.customer_email,
      phone: booking.phone,
      booking_date: booking.booking_date,
      booking_time: booking.booking_time,
      duration_hours: booking.duration_hours,
      total_price: booking.total_price,
      deposit_paid: booking.deposit_paid,
      card_last4: booking.card_last4 || '',
      card_brand: booking.card_brand || '',
      status: booking.status,
      notes: booking.notes || ''
    });
    setShowForm(true);
  };

  const deleteBooking = async (bookingId) => {
    if (!confirm('Delete this booking?')) return;
    try {
      await api.adminDeleteSimBooking(bookingId);
      await loadData();
    } catch (error) {
      console.error('Error deleting booking:', error);
    }
  };

  return (
    <div>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{ fontSize: '16px', color: '#2C6E49' }}>GOLF SIMULATOR BOOKINGS</h3>
        <button 
          onClick={() => { setShowForm(!showForm); setSelectedBooking(null); resetForm(); }}
          className="retro-btn"
          style={{ background: '#2C6E49', color: '#FEFEE3', padding: '10px 20px', fontSize: '12px' }}
        >
          {showForm ? 'CANCEL' : '+ NEW BOOKING'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="retro-card" style={{ background: '#FFF', padding: '20px', marginBottom: '20px' }}>
          <h4 style={{ fontSize: '14px', color: '#2C6E49', marginBottom: '15px' }}>
            {selectedBooking ? 'EDIT BOOKING' : 'NEW BOOKING'}
          </h4>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <input required type="text" placeholder="CUSTOMER NAME" value={formData.customer_name} onChange={(e) => setFormData({...formData, customer_name: e.target.value})} className="retro-input" style={{ width: '100%' }} />
            <input required type="email" placeholder="EMAIL" value={formData.customer_email} onChange={(e) => setFormData({...formData, customer_email: e.target.value})} className="retro-input" style={{ width: '100%' }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <input required type="tel" placeholder="PHONE" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} className="retro-input" style={{ width: '100%' }} />
            <input required type="date" value={formData.booking_date} onChange={(e) => setFormData({...formData, booking_date: e.target.value})} className="retro-input" style={{ width: '100%' }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <input required type="time" value={formData.booking_time} onChange={(e) => setFormData({...formData, booking_time: e.target.value})} className="retro-input" style={{ width: '100%' }} />
            <input required type="number" step="0.5" placeholder="HOURS" value={formData.duration_hours} onChange={(e) => setFormData({...formData, duration_hours: parseFloat(e.target.value)})} className="retro-input" style={{ width: '100%' }} />
            <input required type="number" step="0.01" placeholder="TOTAL $" value={formData.total_price} onChange={(e) => setFormData({...formData, total_price: parseFloat(e.target.value)})} className="retro-input" style={{ width: '100%' }} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <input type="number" step="0.01" placeholder="DEPOSIT $" value={formData.deposit_paid} onChange={(e) => setFormData({...formData, deposit_paid: parseFloat(e.target.value)})} className="retro-input" style={{ width: '100%' }} />
            <input type="text" placeholder="CARD LAST 4" maxLength="4" value={formData.card_last4} onChange={(e) => setFormData({...formData, card_last4: e.target.value})} className="retro-input" style={{ width: '100%' }} />
            <input type="text" placeholder="CARD BRAND" value={formData.card_brand} onChange={(e) => setFormData({...formData, card_brand: e.target.value})} className="retro-input" style={{ width: '100%' }} />
          </div>

          <select value={formData.status} onChange={(e) => setFormData({...formData, status: e.target.value})} className="retro-input" style={{ width: '100%', marginBottom: '15px' }}>
            <option value="pending">PENDING</option>
            <option value="confirmed">CONFIRMED</option>
            <option value="completed">COMPLETED</option>
            <option value="cancelled">CANCELLED</option>
            <option value="no_show">NO SHOW</option>
          </select>

          <textarea placeholder="NOTES" value={formData.notes} onChange={(e) => setFormData({...formData, notes: e.target.value})} className="retro-input" style={{ width: '100%', marginBottom: '15px', minHeight: '60px' }} />

          <button type="submit" className="retro-btn" style={{ background: '#2C6E49', color: '#FEFEE3', padding: '12px 30px', fontSize: '12px' }}>
            {selectedBooking ? 'UPDATE BOOKING' : 'CREATE BOOKING'}
          </button>
        </form>
      )}

      <div>
        {bookings.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#4C956C', padding: '40px' }}>NO BOOKINGS YET</p>
        ) : (
          bookings.map((booking) => (
            <div key={booking._id} className="retro-card" style={{ background: '#FFF', padding: '15px', marginBottom: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <h4 style={{ fontSize: '14px', color: '#2C6E49', fontWeight: 'bold', marginBottom: '5px' }}>
                    {booking.customer_name}
                  </h4>
                  <p style={{ fontSize: '11px', color: '#4C956C', marginBottom: '3px' }}>
                    📧 {booking.customer_email} | 📞 {booking.phone}
                  </p>
                  <p style={{ fontSize: '11px', color: '#2C2C2C', marginBottom: '3px' }}>
                    📅 {booking.booking_date} at {booking.booking_time} • {booking.duration_hours}h
                  </p>
                  <p style={{ fontSize: '11px', color: '#2C2C2C', marginBottom: '5px' }}>
                    💳 {booking.card_brand} ****{booking.card_last4}
                  </p>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span style={{ 
                      background: booking.status === 'confirmed' ? '#2C6E49' : booking.status === 'no_show' ? '#FF5A5F' : '#4C956C',
                      color: '#FFF',
                      padding: '3px 10px',
                      fontSize: '9px',
                      fontWeight: 'bold'
                    }}>
                      {booking.status.toUpperCase()}
                    </span>
                    <span style={{ fontSize: '11px', color: '#2C2C2C' }}>
                      Total: ${booking.total_price} | Deposit: ${booking.deposit_paid}
                    </span>
                  </div>
                </div>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginLeft: '15px' }}>
                  <button onClick={() => handleCharge(booking._id, 'no_show')} className="retro-btn" style={{ background: '#FF5A5F', color: '#FFF', padding: '6px 12px', fontSize: '10px', whiteSpace: 'nowrap' }}>
                    NO SHOW FEE
                  </button>
                  <button onClick={() => handleCharge(booking._id, 'cleaning')} className="retro-btn" style={{ background: '#FFC857', color: '#000', padding: '6px 12px', fontSize: '10px', whiteSpace: 'nowrap' }}>
                    CLEANING FEE
                  </button>
                  <button onClick={() => handleCharge(booking._id, 'add_time')} className="retro-btn" style={{ background: '#4C956C', color: '#FFF', padding: '6px 12px', fontSize: '10px', whiteSpace: 'nowrap' }}>
                    ADD TIME
                  </button>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <button onClick={() => editBooking(booking)} className="retro-btn" style={{ background: '#FFF', border: '2px solid #2C6E49', padding: '6px 10px', fontSize: '10px' }}>✏️</button>
                    <button onClick={() => deleteBooking(booking._id)} className="retro-btn" style={{ background: '#FFF', border: '2px solid #FF5A5F', padding: '6px 10px', fontSize: '10px' }}>🗑️</button>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {charges.length > 0 && (
        <div style={{ marginTop: '30px' }}>
          <h3 style={{ fontSize: '14px', color: '#2C6E49', marginBottom: '15px' }}>RECENT CHARGES</h3>
          {charges.slice(0, 10).map((charge) => (
            <div key={charge._id} className="retro-card" style={{ background: '#FFF', padding: '12px', marginBottom: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ fontSize: '12px', color: '#2C2C2C', fontWeight: 'bold' }}>{charge.customer_name}</p>
                  <p style={{ fontSize: '10px', color: '#4C956C' }}>{charge.description} • {charge.card_brand} ****{charge.card_last4}</p>
                </div>
                <p style={{ fontSize: '14px', color: '#2C6E49', fontWeight: 'bold' }}>${charge.amount.toFixed(2)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SimManager;
